import { supabase } from "../../config/supabase";

 // Create a course
 const createCourse = async (interests = [], challenges = [],title = '',description = '' ) => {
    const newCourse = { 
        interests:interests.map(val => val.toLowerCase()),
        challenges:challenges.map(val => val.toLowerCase()),
        title:title.toLowerCase(),
        description:description.toLowerCase()
    };
    try {
        const { error } = await supabase.from('courses').insert([newCourse]);
        if (error) throw new Error(error);
        return { error: null };
    } catch (err) {
        console.log('an error in creating courses:',err);
        return { error: err };
    }
};

export { createCourse };